module.exports = __webpack_public_path__ + "static/media/screen-individual-03.95968b29.jpg";